/**
 * @Author:
 * @Description:
 * @DateTime: Created in 16:31 2019-07-06
 */
import Keep from "../layout/keep";
import Layout from '../layout/layout';

let SystemConfig = [
    {
        path: '/:type/systemConfig',
        name: 'systemConfig',
        component: Layout,
        children: [
            {
                path: 'stationConfig',
                name: 'stationConfig',
                meta: { title: '站点配置' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'system-config-station-config',
                        meta: { title: '站点配置' },
                        component: () => import('src/pages/systemConfig/stationConfig/stationConfig'),
                    },
                ],
            },{
                path: 'userConfig',
                name: 'userConfig',
                meta: { title: '用户配置' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'system-config-user-config',
                        meta: { title: '用户配置' },
                        component: () => import('src/pages/systemConfig/userConfig/userConfig'),
                    },
                ],
            },{
                path: 'unitConfig',
                name: 'unitConfig',
                meta: { title: '单元配置' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'system-config-unit-config',
                        meta: { title: '单元配置' },
                        component: () => import('src/pages/systemConfig/unitConfig/unitConfig'),
                    },
                ],
            },{
                path: 'video',
                name: 'video',
                meta: { title: '视频密钥' },
                component: Keep,
                children: [
                    {
                        path: 'secretKey',
                        name: 'system-config-unit-config',
                        meta: { title: '视频密钥' },
                        component: () => import('src/pages/systemConfig/video/video'),
                    },
                ],
            },{
                path: 'organizationConfig',
                name: 'organizationConfig',
                meta: { title: '组织配置' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'system-config-organization-config',
                        meta: { title: '组织配置' },
                        component: () => import('src/pages/systemConfig/organizationConfig/organizationConfig'),
                    },
                ],
            },{
                path: 'roleConfig',
                name: 'roleConfig',
                meta: { title: '角色配置' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'system-config-role-config',
                        meta: { title: '角色配置' },
                        component: () => import('src/pages/systemConfig/roleConfig/roleConfig'),
                    },
                    {
                        path: 'menuReleation',
                        name: 'system-config-menu-releation',
                        meta: { title: '菜单接口关联' },
                        component: () => import('src/pages/systemConfig/roleConfig/menuReleation'),
                    },
                ],
            },{
                path: 'menuConfig',
                name: 'menuConfig',
                meta: { title: '菜单配置' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'system-config-menu-config',
                        meta: { title: '菜单配置' },
                        component: () => import('src/pages/systemConfig/menuConfig/menuConfig'),
                    },
                ],
            }
        ],
    }
]

export default SystemConfig
